/**
 * Component Registry for Waterford Place Apartments & Townhomes
 * 
 * Inherits from @vibesites-price-brothers/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-preferred/registry';
import { SisterProperties } from './components/SisterProperties';
import { Header } from './components/Header';
import { PreferredEmployerCTA } from './components/PreferredEmployerCTA';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  SisterProperties,
  Header,
  PreferredEmployerCTA,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
